import { useTranslation } from 'react-i18next'
import { Tune as TuneIcon } from '@mui/icons-material'
import { Box, CircularProgress, IconButton, SxProps, Theme } from '@mui/material'

import { useAuth } from '@hooks'
import { USER_ROLES } from '@constants'

interface SaveUserRestrictionsButtonProps {
  onClick: () => void
  loading: boolean
  sx?: SxProps<Theme>
}

const SaveUserRestrictionsButton: React.FC<SaveUserRestrictionsButtonProps> = props => {
  const { onClick, loading, sx } = props

  const { t } = useTranslation()
  const { hasRole } = useAuth()
  const isAdmin = hasRole([USER_ROLES.ADMIN])

  if (!isAdmin) {
    return null
  }

  return (
    <Box
      sx={{
        mr: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 20,
        width: 20,
        p: 0,
      }}
    >
      {loading ? (
        <CircularProgress size={14} />
      ) : (
        <IconButton
          size={'small'}
          sx={sx}
          title={t('tooltip.useUserRestrictions')}
          onClick={onClick}
        >
          <TuneIcon sx={{ width: 18, height: 18 }} />
        </IconButton>
      )}
    </Box>
  )
}

export { SaveUserRestrictionsButton }
